<section class="mt-grid in10" v-if="isSet()">
  <div class="row">
    <div class="col is5 is9-xs is9-s">
      <label
        :for="$vId(this, 'displaystyle')"
        class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size20"
      >
        {{$t('pages.submissions.components.upload.fontmeta.defaultstyle.label')}}
      </label>
      <div :class="$style.designerLabelSection">
        {{$t('pages.submissions.components.upload.fontmeta.defaultstyle.description')}}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col is5 is9-xs is9-s">
      <VSelect
      ref="displaystyle"
       deselect-from-dropdown
        truncate-label
        name="display style upload"
        label="display style"
        type="radio"
        :id="$vId(this, 'displaystyle')"
        :input-class="[inputFont, inputWidth]"
        :error-class="[errorCSS]"
        :options="displaystyle.options"
        @update:modelValue="updateDisplayStyleValues"
        rules="required"
        v-model="displaystyle.values"
        :initial-value="displaystyle.values"
        :reduce="op => op"
        :isError="Object.hasOwn(errors, 'display style upload')"
        :placeholder="$t('pages.submissions.components.upload.fontmeta.defaultstyle.placeholder')"
        @option:selected="updateDisplayStyleValues"
        @option:deselected="optionDeselected"
        :on-change="updateDisplayStyleValues"
      />
    </div>
  </div>
</section>
